import { IRoute } from "src/pages/Router/routes";

import ViewProductDetailsPage from "./ViewProductDetailsPage";

export const CustomerProducts: IRoute[] = [
  {
    exact: true,
    path: "/products/:productId",
    pageComponent: ViewProductDetailsPage,
    title: "%PRODUCT% Details",
    allowedContexts: [ "ORDER_PRODUCT_SELECTION", "LIST_PRODUCT_SELECTION" ],
    menuType: "MAIN",
    privateRoute: true,
    roles: [ "customer" ],
    permissions: [ "view-product" ],
    hidden: true
  }
];

export default CustomerProducts;
